import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from "../Services/MemberShip";
import APIS from "../Services/Auth";
import TaxRateListList from "../Components/TaxRate";
import moment from "moment";

const MemberShipList = () => {
    const [name, setName] = useState("");
    const [duration, setDuration] = useState([]);
    const [price, setPrice] = useState("");
    const [taxRateData, setTaxRateData] = useState("");
    const [descriptionOne, setDescriptionOne] = useState("");
    const [descriptionTwo, setDescriptionTwo] = useState("");
    const [error, setError] = useState({});
    const [selectedDuration, setSelectedDuration] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [membershipList, setMemberShipist] = useState([])
    const perPage = 10
    const [id, setId] = useState([])
    const [taxRateName, setTaxRateName] = useState("");
    const [status, setStatus] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [getLogo, setGetLogo] = useState("")
    const [logoPreview, setLogoPreview] = useState(null);
    const [logo, setLogo] = useState("");
    const [loyaltyPoint, setLoyaltyPoint] = useState("");
    const [eligibilityCriteria, setEligibilityCriteria] = useState("");
    const [discount, setDiscount] = useState("");
    const [spent, setSpent] = useState("")
    const [bonusloyalty, setBonusloyalty] = useState("")
    const [skyCoins, setSkyCoins] = useState("");


    useEffect(() => {
        getDurationList();
        getMemberShipList()
    }, [currentPage]);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;

            case "eligibilityCriteria":
                setEligibilityCriteria(value);
                break;
            case "selectedDuration":
                setSelectedDuration(value);
                break;
            case "descriptionOne":
                setDescriptionOne(value);
                break;
            case "descriptionTwo":
                setDescriptionTwo(value);
                break;
            case "discount":
                setDiscount(value);
                break;
            case "loyaltyPoint":
                setLoyaltyPoint(value);
                break;
            case "spent":
                setSpent(value);
                break;
            case "bonusloyalty":
                setBonusloyalty(value);
                break
            case "skyCoins":
                setSkyCoins(value);
                break;
            default:
                break;
        }
    };
    const validateFields = () => {
    const errors = {};
    const nameRegex = /^[A-Za-z\s]+$/;

    if (!name?.trim()) {
        errors.name = "Name is required";
    } else if (!nameRegex.test(name)) {
        errors.name = "Name can only contain letters";
    }

    const priceRegex = /^\d+(\.\d{0,2})?$/;
    if (eligibilityCriteria === "" || eligibilityCriteria === null || eligibilityCriteria === undefined) {
        errors.eligibilityCriteria = "Eligibility Criteria is required";
    } else if (!priceRegex.test(String(eligibilityCriteria))) {
        errors.eligibilityCriteria = "Eligibility Criteria must be a valid number (e.g., 100 or 100.50)";
    }

    const discountRegex = /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/;
    if (discount === "" || discount === null || discount === undefined) {
        errors.discount = "Party Activity Discount is required";
    } else if (!discountRegex.test(String(discount))) {
        errors.discount = "Discount must be a valid percentage (0 - 100)";
    } else if (parseFloat(discount) < 0 || parseFloat(discount) > 100) {
        errors.discount = "Discount must be between 0 and 100";
    }

    const loyaltyRegex = /^\d+(\.\d{1,2})?$/;
    if (loyaltyPoint === "" || loyaltyPoint === null || loyaltyPoint === undefined) {
        errors.loyaltyPoint = "Loyalty Point is required";
    } else if (!loyaltyRegex.test(String(loyaltyPoint))) {
        errors.loyaltyPoint = "Loyalty Point must be a valid number";
    }

    if (spent === "" || spent === null || spent === undefined) {
        errors.spent = "Spent is required";
    } else if (!priceRegex.test(String(spent))) {
        errors.spent = "Spent must be a valid number";
    }

    const bonusloyaltyRegex = /^\d+(\.\d{1,2})?$/;
    if (bonusloyalty === "" || bonusloyalty === null || bonusloyalty === undefined) {
        errors.bonusloyalty = "Bonus Loyalty Points is required";
    } else if (!bonusloyaltyRegex.test(String(bonusloyalty))) {
        errors.bonusloyalty = "Bonus Loyalty Points must be a valid number";
    }

    if (skyCoins === "" || skyCoins === null || skyCoins === undefined) {
        errors.skyCoins = "SkyCoins is required";
    } else if (!discountRegex.test(String(skyCoins))) {
        errors.skyCoins = "SkyCoins must be a valid percentage (0 - 100)";
    } else if (parseFloat(skyCoins) < 0 || parseFloat(skyCoins) > 100) {
        errors.skyCoins = "SkyCoins must be between 0 and 100";
    }

    setError(errors);
    return Object.keys(errors).length === 0;
};



    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedDuration(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.selectedDuration;
            return updatedErrors;
        });
    };

    const handleTaxRateChange = (value) => {
        setTaxRateData(value);
    };
    const handleError = (error) => {
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const getDurationList = async () => {
        try {
            const response = await APIS.getDurationData({ is_active: true });
            setDuration(response?.data?.data?.rows);
        } catch (error) {
            setError((prevErrors) => ({
                ...prevErrors,
                duration: "Failed to fetch duration data.",
            }));
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
          //  console.log('Unauthorized access', error);
            handleError(error);
        }
    };
    const getMemberShipList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getMemberShip(payload);
            setMemberShipist(response?.data?.data?.rows);
          //  console.log('response?.data?.data?.rows', response?.data?.data?.rows);
            setTotalRecords(response?.data?.data?.count);
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getMemberShipList();
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };
    const changeStatus = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeMemberShipStatus(id, updatedStatus);
            if (response.status === 200) {
                setMemberShipist((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Membership ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getMemberShipList();
                //setTimeout(() => window.location.reload(), 2000);
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };

    const handleGetData = async (membershipId) => {
        try {
            const response = await API.getMemberShip({ id: membershipId });
            const fetchedData = response?.data?.data?.rows?.[0];
           // console.log('fetchedData', fetchedData);
            if (fetchedData) {
                setId(fetchedData.id);
                setName(fetchedData.name);
                setSelectedDuration(fetchedData?.duration_id);
                setPrice(fetchedData?.price)
                setTaxRateData(fetchedData?.tax_rate_id);
                setDescriptionOne(fetchedData?.description_one);
                setDescriptionTwo(fetchedData?.description_two);
                setTaxRateName(fetchedData?.tax_rate_name);
                setStatus(fetchedData?.is_active);
                setCreatedAt(fetchedData?.createdAt);
                setLogoPreview(fetchedData?.logo)
                setEligibilityCriteria(fetchedData.eligibility_criteria);
                setDiscount(fetchedData?.additional_discount);
                setLoyaltyPoint(fetchedData?.loyalty_point);
                setSpent(fetchedData?.play_point_spent)
                setBonusloyalty(fetchedData?.additional_loyalty_point)
                setSkyCoins(fetchedData?.additional_point_percentage)
            } else {
                toast.error("Failed to fetch membership details.");
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };
    const updateMembershipData = async () => {
        if (!validateFields()) return;
        const formData = new FormData();
        formData.append("company_id", 1);
        formData.append("name", name);
        formData.append("eligibility_criteria", eligibilityCriteria);
        formData.append("additional_discount", discount);

        formData.append("is_active", true);
        formData.append("loyalty_point", loyaltyPoint)

        formData.append("duration", parseInt(1));
        formData.append("tax_rate_id", parseInt(1));
        formData.append("play_point_spent", spent)
        formData.append("additional_loyalty_point", bonusloyalty)
        formData.append("additional_point_percentage", skyCoins)

        let updatedLogo = logo || logoPreview;
        if (updatedLogo && typeof updatedLogo === "object" && updatedLogo instanceof Blob) {
            formData.append("logo", updatedLogo);
        } else {

        }

        for (let pair of formData.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }

        try {
            const response = await API.updateMemberShipStatus(id, formData);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Membership created successfully!");
                setTimeout(() => window.location.reload(), 2000);

            } else {
                toast.error(response?.data?.message || "Membership not added. Please try again later.");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.message);
        }
    };



    const handleSubmit = async () => {
        if (!validateFields()) return;
        await updateMembershipData();
    };
    const handleCancel = () => {
        window.location.reload();
        setId(null);

    };
    const handleGetLogo = (logo) => {
        setGetLogo(logo);
    }
    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedFormats = ['image/jpeg', 'image/png', 'image/gif'];
            const maxSize = 5 * 1024 * 1024;
            if (!allowedFormats.includes(file.type)) {
                toast.error("Only JPG PNG and GIF formats are allowed.")
                event.target.value = '';
                return;
            }
            if (file.size > maxSize) {
                toast.error("File size must be 5MB or smaller.")
                event.target.value = '';
                return;
            }
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors.logo;
                return updatedErrors;
            });
            setLogo(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">MemberShip</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        {/* <th>Duration</th> */}
                                        <th>Eligibility Criteria</th>
                                        <th>Party Activity Discount (%) </th>
                                        <th>Earned Loyality Points </th>
                                        <th>SkyCoins Spent</th>
                                        <th>Bonus Loyalty Points</th>
                                        <th>Sky Coins (%)</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                        <th>Image</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {membershipList.map((item, index) => (

                                        <tr
                                            key={item.id}
                                            data-active={item?.is_active ? "true" : "false"}
                                        >

                                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalViewMemberShip">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                {/* <a className="dropdown-item">
                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>
                                                                </a> */}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>

                                            <td>{item.name}</td>
                                            {/* <td>{item.duration}</td> */}
                                            <td>{item.eligibility_criteria}</td>
                                            {/* <td>{item.additional_discount} % </td> */}
                                            <td>
                                                {item.additional_discount !== undefined && item.additional_discount !== null && item.additional_discount !== ''
                                                    ? `${item.additional_discount} %`
                                                    : ''}
                                            </td>
                                            <td>{item?.loyalty_point}</td>
                                            <td>{item?.play_point_spent}</td>
                                            <td>{item?.additional_loyalty_point}</td>
                                            <td>{item?.additional_point_percentage}</td>
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}

                                            </td>
                                            <td>
                                                {item.logo && item.logo.trim() !== "" ? (
                                                    <button
                                                        onClick={() => handleGetLogo(item.logo)}
                                                        className="btn btn-success btn-sm"
                                                        type="button"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#myModallogo"
                                                    >
                                                        View
                                                    </button>
                                                ) : "N/A"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section>
                <div className="modal fade" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog  modal-lg">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h4 className="modal-title">Update MemberShip</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Name <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => handleFieldChange(e, "name")}
                                        />
                                        {error?.name && <span className="text-danger">{error.name}</span>}
                                    </div>

                                    <div className="col-md-4">
                                        <label>Eligibility Criteria <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={eligibilityCriteria}
                                            onChange={(e) => handleFieldChange(e, "eligibilityCriteria")}
                                        />
                                        {error?.eligibilityCriteria && <span className="text-danger">{error.eligibilityCriteria}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <label>Party Activity Discount (%) <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={discount}
                                            onChange={(e) => handleFieldChange(e, "discount")}
                                        />
                                        {error?.discount && <span className="text-danger">{error.discount}</span>}
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-4">
                                        <label>Earned LoyalityPoints (Transaction) <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={loyaltyPoint}
                                            onChange={(e) => handleFieldChange(e, "loyaltyPoint")}
                                        />
                                        {error?.loyaltyPoint && <span className="text-danger">{error.loyaltyPoint}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="name">SkyCoins Spent <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtSpent"
                                                placeholder="Spent"
                                                value={spent}
                                                onChange={(e) => handleFieldChange(e, "spent")}
                                            />
                                            {error?.spent && (
                                                <span className="text-danger">
                                                    {error.spent}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label>Bonus Loyalty Points (From Membership) <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={bonusloyalty}
                                            onChange={(e) => handleFieldChange(e, "bonusloyalty")}
                                        />
                                        {error?.bonusloyalty && <span className="text-danger">{error.bonusloyalty}</span>}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label>SkyCoins(%)<span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={skyCoins}
                                                onChange={(e) => handleFieldChange(e, "skyCoins")}
                                            />
                                            {error?.skyCoins && <span className="text-danger" style={{ fontSize: "12px" }}>{error.skyCoins}</span>}
                                        </div>
                                        <div className="col-md-4">
                                            <label>Upload Card Image </label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={handleLogoChange}
                                            />

                                            {error?.logo && <span className="text-danger">{error.logo}</span>}
                                        </div>
                                        <div className="col-md-4">
                                            {logoPreview && (
                                                <div className="mt-2">
                                                    <img src={logoPreview || 'No Image Available'} alt="Logo Preview" style={{ width: 100, height: 100, objectFit: 'cover' }} />
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                                <div className="mt-2">
                                    <button className="btn btn-primary me-3" type="button" onClick={handleSubmit}>Update</button>

                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalViewMemberShip">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Discount Details</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <table className="table table-bordered border-secondary">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Eligibility Criteria</th>
                                            <th>Party Activity Discount (%)</th>
                                        </tr>
                                        <tr>
                                            <td>{name}</td>
                                            <td>{eligibilityCriteria}</td>
                                            <td>
                                                {discount !== undefined && discount !== null && discount !== ''
                                                    ? `${discount} %`
                                                    : ''}

                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Earned Loyality Points (Transaction) </th>
                                            <th>Spent</th>
                                            <th>Bonus Loyalty Points (From Membership)</th>

                                            {/* <th>Discription 1</th>
                                            <th>Discription 2</th> */}
                                        </tr>
                                        <tr>
                                            <td>{loyaltyPoint}</td>
                                            <td>{spent}</td>
                                            <td>{bonusloyalty}</td>
                                            {/* <td>{descriptionOne}</td>
                                            <td>{descriptionTwo}</td> */}
                                        </tr>
                                        <tr>
                                            <th>Status</th>
                                            <th>Created Date</th>
                                            <th>Card Image</th>
                                        </tr>
                                        <tr>
                                            <td>{status ? "Active" : "De-Activated"}</td>
                                            {/* <td><img src={logoPreview} alt="Logo" style={{ width: '20%', height: '100px' }} /></td> */}
                                            {/* <td><img src={logoPreview || 'No Image Available'} alt="Image" /></td> */}
                                            <td>{moment(createdAt).format("DD-MM-YYYY")}
                                            </td>
                                            <td>
                                                {logoPreview ? (
                                                    <img
                                                        src={logoPreview}
                                                        alt="Image"
                                                        width="50"
                                                        height="50"

                                                    />
                                                ) : (
                                                    <span>No Image Available</span>
                                                )}

                                            </td>


                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="modal" id="myModallogo">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Card Image</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row my-3" style={{ justifyContent: "center" }}>
                                    <img src={getLogo || 'No Image Available'} alt="Logo" style={{ "width": "200px", "height": "150px" }} />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default MemberShipList;
